<style scoped>
    @import url("../../../styles/smartControl/cardReceita.scss");
</style>

<template>
    <div class="box_cardReceita mt-2">

        <div class="linhaZero">
            <v-chip size="x-small" color="white">{{ group.group }}</v-chip>
            <v-chip v-if="group.name == null" class="ml-1" size="x-small" color="white">
                Grupo sem nome
            </v-chip>
            <v-chip v-else class="ml-1" size="x-small" color="white">
                {{ group.name }}
            </v-chip>
            <v-icon class="ml-1">mdi-note-edit</v-icon>
        </div>

        <div class="linhaUm">
            <div class="colUm">
                <span :style="{'color':'#F39C12'}">fertilizationTime:
                    <span :style="{'color':'white'}">{{ group.fertilizationTime }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">fertilizationVolume:
                    <span :style="{'color':'white'}">{{ group.fertilizationVolume }}</span>
                </span>
            </div>

            <div class="colUm">
                <span :style="{'color':'#F39C12'}">fertilizerFormula:
                    <span :style="{'color':'white'}">{{ group.fertilizerFormula }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">preFertilizerFormula:
                    <span :style="{'color':'white'}">{{ group.preFertilizerFormula }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">postFertilizerFormula:
                    <span :style="{'color':'white'}">{{ group.postFertilizerFormula }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">preIrrigationTime:
                    <span :style="{'color':'white'}">{{ group.preIrrigationTime }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">preIrrigationVolume:
                    <span :style="{'color':'white'}">{{ group.preIrrigationVolume }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">postIrrigationTime:
                    <span :style="{'color':'white'}">{{ group.postIrrigationTime }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">postIrrigationVolume:
                    <span :style="{'color':'white'}">{{ group.postIrrigationVolume }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">pump1:
                    <span :style="{'color':'white'}">{{ group.pump1 }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">pump2:
                    <span :style="{'color':'white'}">{{ group.pump2 }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">pump3:
                    <span :style="{'color':'white'}">{{ group.pump3 }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">valves:
                    <span :style="{'color':'white'}">{{ group.valves }}</span>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['group'],
}
</script>